import script from "./AboutVentureCapital.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutVentureCapital.vue?vue&type=script&setup=true&lang=js"

import "./AboutVentureCapital.vue?vue&type=style&index=0&id=7874c990&scoped=true&lang=css"

import exportComponent from "/home/sino/SinoData/jenkins/.jenkins/workspace/enterpriseprodex/sxpf-cms-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7874c990"]])

export default __exports__